import { render } from "react-dom";
import React from "react";

export default async function initHeroAnimation() {
   const animationContainer = document.getElementById("foslp-hero-animation");
   
   if (animationContainer) {
      const animate = matchMedia("(prefers-reduced-motion)").matches === false 
         || LiquidSpaceConfig.DEBUG;

      if (animate) {
         const moduleExport = await import("./HeroAnimation");
         const HeroAnimation = moduleExport.default;
         render(<HeroAnimation />, animationContainer);
      }
   }
}